export class VoucherBuildData{
    module = {
        name: "Vouchers",
        new_name: "vouchers",
        filtered_name:"Vouchers",
        has_dot_menu: true,
        icon:'fa-maps',
        permission:'vouchers'
    }
}